import React, { createContext, useState, useContext } from "react";
import { ToastContainer } from "react-toastify";

import SegmentNew from "./SegmentNew";

const SegmentNewContext = createContext();

export function useSegmentNewContext() {
  return useContext(SegmentNewContext);
}

const SegmentNewProvider = (props) => {
  const {
    csrfToken,
    user,
    team,
    venueOwnerships,
    lastTouchedVenueOwnership,
    aiSegmentBuilder,
  } = props;

  const [selectedVenueOwnership, setSelectedVenueOwnership] = useState(lastTouchedVenueOwnership);
  const [segment, setSegment] = useState({
    type: "Segments::DataDriven",
    name: "",
    venue_ownership_id: lastTouchedVenueOwnership?.id || null,
  });

  const value = {
    csrfToken,
    user,
    team,
    venueOwnerships,
    selectedVenueOwnership,
    setSelectedVenueOwnership,
    segment,
    setSegment,
    aiSegmentBuilder,
  };

  return (
    <SegmentNewContext.Provider value={value}>
      {props.children}
    </SegmentNewContext.Provider>
  );
};

const SegmentNewContainer = (props) => (
  <SegmentNewProvider {...props}>
    <ToastContainer icon={false} />
    <SegmentNew />
  </SegmentNewProvider>
);

export default SegmentNewContainer;
